exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":host{display:flex;flex-direction:column;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/shared/components/identite-organisme/nom-entreprise/nom-entreprise.component.scss
// module id = 743
// module chunks = 0